import React from 'react';

/** Pasos del procedimiento de una receta (texto seleccionable, no imagen). */
export function RecipeSteps({
  steps
}: {
  steps: string[];
}) {
  return <ol className="space-y-2" data-id="element-1047" data-mp="w0sr6x3eo2j6">
      {steps.map((s, i) => <li key={s} className="flex gap-3 text-sm text-gray-200 md:text-[15px]" data-id="element-1048" data-mp="10un8jtvjg5f3" data-mpi={i}>
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#D4AF37]/15 text-xs font-bold text-[#D4AF37]" data-id="element-1049" data-mp="15syh81a3k9vq">{i + 1}</span>
          <span className="pt-0.5" data-id="element-1050" data-mp="8716wr5vfauv">{s}</span>
        </li>)}
    </ol>;
}

/** Etiqueta de receta clásica: identificar ingredientes no confirma cantidades, coste ni condiciones. */
export function ClassicRecipeLabel() {
  return <span className="inline-flex items-center rounded-full border border-sky-300/30 bg-sky-300/10 px-2.5 py-1 text-xs font-semibold text-sky-100" data-id="element-1051" data-mp="n1xmxqjx92ii">Receta clásica · pendiente de validar en Vanguard</span>;
}